// premium-theme.js

(function() {
  // Global Night Mode Function
  window.toggleNightMode = function(forceMode) {
    const isNight = forceMode !== undefined ? forceMode : !document.documentElement.classList.contains('night-mode');
    
    if (isNight) {
      document.documentElement.classList.add('night-mode');
      document.body.setAttribute('data-night-mode', 'true');
      localStorage.setItem('premium-night-mode', 'true');
    } else {
      document.documentElement.classList.remove('night-mode');
      document.body.removeAttribute('data-night-mode');
      localStorage.setItem('premium-night-mode', 'false');
    }

    // Update icons across all toggle buttons
    document.querySelectorAll('.premium-night-toggle__sun').forEach(el => el.style.display = isNight ? 'block' : 'none');
    document.querySelectorAll('.premium-night-toggle__moon').forEach(el => el.style.display = isNight ? 'none' : 'block');
  };

  // Get Wishlist Storage Key (Customer Account linked or Guest)
  window.getWishlistStorageKey = function() {
    if (window.ShopifyCustomer && window.ShopifyCustomer.isLoggedIn && window.ShopifyCustomer.id) {
      return 'premium_wishlist_customer_' + window.ShopifyCustomer.id;
    }
    return 'premium_wishlist_guest';
  };

  window.getWishlist = function() {
    const key = window.getWishlistStorageKey();
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(key) || '[]');
    } catch(e) {}
    
    // If logged in, merge guest items once
    if (window.ShopifyCustomer && window.ShopifyCustomer.isLoggedIn) {
      try {
        const guestList = JSON.parse(localStorage.getItem('premium_wishlist_guest') || '[]');
        if (guestList.length > 0) {
          guestList.forEach(item => {
            if (!list.includes(item)) list.push(item);
          });
          localStorage.setItem(key, JSON.stringify(list));
          localStorage.removeItem('premium_wishlist_guest'); // cleared after merging to account
        }
      } catch(e) {}
    }
    return list;
  };

  window.saveWishlist = function(list) {
    const key = window.getWishlistStorageKey();
    localStorage.setItem(key, JSON.stringify(list));
  };

  document.addEventListener('DOMContentLoaded', () => {
    
    // Check initial Night Mode state
    const isNightMode = localStorage.getItem('premium-night-mode') === 'true';
    window.toggleNightMode(isNightMode);

    // Bind Night Mode Toggle buttons
    document.querySelectorAll('#nightModeToggle, #nightModeTogglePdp, .premium-night-toggle-pdp').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.toggleNightMode();
      });
    });

    // Scroll Animations
    const animatedElements = document.querySelectorAll('.fade-in-up, .fade-in-left, .fade-in-right');
    if (animatedElements.length > 0 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      });

      animatedElements.forEach(el => observer.observe(el));
    } else {
      animatedElements.forEach(el => el.classList.add('is-visible'));
    }

    // Hero Slider (if custom section present)
    const sliders = document.querySelectorAll('.premium-hero');
    sliders.forEach(slider => {
      const slides = slider.querySelectorAll('.premium-hero__slide');
      const dots = slider.querySelectorAll('.premium-hero__dot');
      const prevBtn = slider.querySelector('.premium-hero__nav--prev');
      const nextBtn = slider.querySelector('.premium-hero__nav--next');
      
      if (slides.length <= 1) return;

      let currentIndex = 0;
      let slideInterval;
      const intervalTime = 5000;

      const goToSlide = (index) => {
        slides[currentIndex].classList.remove('active');
        if (dots.length > 0) dots[currentIndex].classList.remove('active');
        
        currentIndex = index;
        if (currentIndex >= slides.length) currentIndex = 0;
        if (currentIndex < 0) currentIndex = slides.length - 1;
        
        slides[currentIndex].classList.add('active');
        if (dots.length > 0) dots[currentIndex].classList.add('active');
      };

      const nextSlide = () => goToSlide(currentIndex + 1);
      const prevSlide = () => goToSlide(currentIndex - 1);

      const startSlide = () => {
        slideInterval = setInterval(nextSlide, intervalTime);
      };

      const stopSlide = () => {
        clearInterval(slideInterval);
      };

      if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goToSlide(index));
      });

      slider.addEventListener('mouseenter', stopSlide);
      slider.addEventListener('mouseleave', startSlide);

      startSlide();
    });

    // Product Gallery Image Swap & Zoom
    const pdpGalleries = document.querySelectorAll('.premium-pdp__gallery, .premium-product-page__gallery');
    pdpGalleries.forEach(gallery => {
      const mainImage = gallery.querySelector('.premium-product-page__main-image, img');
      const mainImageWrap = gallery.querySelector('.premium-product-page__main-image-wrap, .premium-pdp__main-image');
      const thumbnails = gallery.querySelectorAll('.premium-product-page__thumb, .premium-pdp__thumbnail');

      if (mainImage && thumbnails.length > 0) {
        thumbnails.forEach(thumb => {
          thumb.addEventListener('click', () => {
            const imgSrc = thumb.dataset.src || (thumb.querySelector('img') ? thumb.querySelector('img').src : null);
            if (imgSrc) {
              mainImage.src = imgSrc;
              if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
            }
            thumbnails.forEach(t => t.classList.remove('is-active', 'active'));
            thumb.classList.add('is-active', 'active');
          });
        });
      }

      if (mainImageWrap && mainImage) {
        mainImageWrap.addEventListener('mousemove', (e) => {
          const { left, top, width, height } = mainImageWrap.getBoundingClientRect();
          const x = (e.clientX - left) / width * 100;
          const y = (e.clientY - top) / height * 100;
          mainImage.style.transformOrigin = `${x}% ${y}%`;
          mainImage.style.transform = 'scale(1.8)';
        });

        mainImageWrap.addEventListener('mouseleave', () => {
          mainImage.style.transformOrigin = 'center center';
          mainImage.style.transform = 'scale(1)';
        });
      }
    });

    // Initialize Wishlist Button States across page
    const wishlistBtns = document.querySelectorAll('.premium-product-card__wishlist, .premium-pdp-wishlist');
    const currentWishlist = window.getWishlist();

    wishlistBtns.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const icon = btn.querySelector('svg');

      if (handle && currentWishlist.includes(handle)) {
        btn.classList.add('active');
        if (icon) {
          icon.setAttribute('fill', '#FF4FD8');
          icon.setAttribute('stroke', '#FF4FD8');
        }
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentHandle = btn.getAttribute('data-product-handle');
        let wishlist = window.getWishlist();
        const isActive = btn.classList.contains('active');

        if (isActive) {
          btn.classList.remove('active');
          if (icon) {
            icon.setAttribute('fill', 'none');
            icon.setAttribute('stroke', 'currentColor');
          }
          if (currentHandle) {
            wishlist = wishlist.filter(h => h !== currentHandle);
          }
        } else {
          btn.classList.add('active');
          if (icon) {
            icon.setAttribute('fill', '#FF4FD8');
            icon.setAttribute('stroke', '#FF4FD8');
          }
          if (currentHandle && !wishlist.includes(currentHandle)) {
            wishlist.push(currentHandle);
          }
        }
        window.saveWishlist(wishlist);
      });
    });

  });
})();
